import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { FunctionComponent } from 'react';

type ArtLampProps = {
    className?: string;
};

const ArtLamp: FunctionComponent<ArtLampProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'art-lamp'}
            x="0px"
            y="0px"
            viewBox="0 0 250 250"
        >
            <path
                d="M230.4 26.6c-1-6.3-4.8-10-10.3-10h-57.9c-5.6 0-10.7 4.5-11.3 10l-11.7 67.2v.7c0 5.9 4.6 10.6 10.3 10.6h37.8v126.7h-21.8v8h51.3v-8H195V105.2h37.9c5.7 0 10.3-4.8 10.3-10.6v-.3l-12.8-67.7zm5.1 68.2c-.3 1.2-1.3 2.4-2.7 2.4h-83.4c-1.3 0-2.3-1-2.5-2.3L158.6 28v-.2c.2-1.6 1.9-3 3.6-3h57.9c.7 0 2.1 0 2.6 3.4l12.8 66.6z"
                className="st0"
            />
            <path
                d="M111.6 148.7V82.9c0-1.6-1.3-2.9-2.9-2.9H22.1c-1.6 0-2.9 1.3-2.9 2.9v65.9s0 2.9 2.9 2.9h86.6c1.6 0 2.9-1.3 2.9-3zM25 145.6l16.6-14.9 7.3 7.2 24.7-22.1 31.8 29.9H25v-.1zm80.8-8.1l-32.1-30.2-24.6 22-7.3-7.2-16.8 15V85.8h80.8v51.7z"
                className="st0"
            />
            <path
                d="M122.9 101.6c0-.3 0-.5-.1-.8l-3.6-13.5 2.9-15c.1-.4.1-.7 0-1.1-.1-.8-.6-1.5-1.2-1.9-.6-.4-1.4-.6-2.1-.5l-18.1 3.4-17.1-3.7c-.4-.1-.8-.1-1.2 0l-17 3.7-17-3.7c-.4-.1-.8-.1-1.2 0l-17 3.7L12 68.8c-.9-.2-1.9.1-2.6.8-.7.7-1 1.7-.8 2.6l2.9 15.1L8 100.9c-.1.5-.1 1 0 1.5l3.6 13.4L8 129.3c-.1.5-.1 1 0 1.5l3.6 13.5-2.9 15c-.1.4-.1.7 0 1.1.1.8.6 1.5 1.2 1.9.6.4 1.4.6 2.1.5l18.2-3.4 17 3.7c.2 0 .4.1.6.1.2 0 .4 0 .6-.1l17-3.7 17 3.7c.4.1.8.1 1.2 0l17-3.7 18.2 3.4c.4.1.7.1 1.1 0 1.6-.3 2.6-1.9 2.3-3.4l-2.9-15.1 3.6-13.6c.1-.5.1-1 0-1.5l-3.6-13.4 3.6-13.4v-.8zM17.4 144.8c.1-.4.1-.9 0-1.3L13.8 130l3.6-13.4c.1-.5.1-1 0-1.5l-3.6-13.4 3.6-13.4c.1-.4.1-.9 0-1.3l-2.2-11.5L29.8 78c.4.1.8.1 1.1 0l17-3.7 17 3.7c.4.1.8.1 1.2 0l17-3.7 17 3.7c.4.1.7.1 1.1 0l14.5-2.7-2.2 11.5c-.1.4-.1.9 0 1.3l3.6 13.4-3.6 13.4c-.1.5-.1 1 0 1.5L117 130l-3.6 13.4c-.1.2-.1.5-.1.8 0 .2 0 .4.1.6l2.2 11.5-14.6-2.7c-.4-.1-.8-.1-1.1 0l-17 3.7-17-3.7c-.4-.1-.8-.1-1.2 0l-17 3.7-17-3.7c-.2 0-.4-.1-.6-.1h-.5L15 156.2l2.4-11.4z"
                className="st0"
            />
            <path
                d="M38.3 116.7c6.6 0 12-5.3 12-11.8 0-6.5-5.4-11.8-12-11.8s-12 5.3-12 11.8c-.1 6.4 5.3 11.8 12 11.8zm-5.7-11.9c0-3 2.5-5.5 5.7-5.5s5.7 2.5 5.7 5.5c0 3.1-2.5 5.5-5.7 5.5s-5.7-2.4-5.7-5.5z"
                className="st0"
            />
        </svg>
    );
};

export default ArtLamp;
